module.exports = __webpack_public_path__ + "img/unit3-federated.7c9c7c79.svg";